import React, { useState, useEffect } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import { Button, Typography, Box } from "@mui/material";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";

// Register chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// Assuming that API_URL is an environment variable or constant containing the base URL of your backend API
const API_URL = process.env.REACT_APP_API_URL;

const ViewsLikesAnalyticsRequest = ({ requestId }) => {
  const [postData, setPostData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (requestId) {
      handleFetchData();
    }
  }, [requestId]); // Fetch data when postId changes

  // Fetch data from Django backend when postId is set
  const handleFetchData = () => {
    if (!requestId) {
      setError("Request ID is required");
      return;
    }

    setError(""); // Clear previous errors

    axios
      .post(`${API_URL}/request/`, { request_id: requestId }) // Send post_id in the request body
      .then((response) => {
        setPostData(response.data);
      })
      .catch((error) => {
        setError("There was an error fetching the post data.");
        console.error(error);
      });
  };

  // Prepare chart data
  const chartData = {
    labels: ["Views", "Likes", "Dislikes", "Acceptance"], // Added "Bookings" as a new category
    datasets: [
      {
        label: "Request Metrics",
        data: [
          postData?.views, 
          postData?.likes, 
          postData?.dislikes, 
          postData?.booking_count || 0  // Add the booking count (0 as fallback if not available)
        ],
        backgroundColor: ["#42A5F5", "#66BB6A", "#FF7043", "#FFEB3B"], // Colors for bars
        borderColor: ["#1E88E5", "#388E3C", "#F4511E", "#FBC02D"], // Border colors
        borderWidth: 1,
      },
    ],
  };

  return (
    <Box p={3}>
     
      <Typography
  variant="h4"
  component="h1"
  gutterBottom
  sx={{
    fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2rem', lg: '2.2rem', xl: '2.5rem' },  // Adjust font size based on screen size
    fontWeight: 'bold',
    textAlign: 'center',  // Center the text
    marginTop: { xs: '1rem', sm: '1.5rem', md: '2rem' },  // Responsive margin top
    color: '#333',  // Optional: Set a dark color for contrast
  }}
>
  Request Metrics Bar Chart
</Typography>


      {error && <Typography color="error">{error}</Typography>}

      {!postData && !error && (
        <Button variant="contained" color="primary" onClick={handleFetchData}>
          Load Post Data
        </Button>
      )}

      {postData && (
        <Box mt={3}>
          <Bar data={chartData} options={{ responsive: true }} />
        </Box>
      )}
    </Box>
  );
};

export default ViewsLikesAnalyticsRequest;
